import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import {
  getPreferences,
  putPreferences
} from "../../../modules/preferences/action";
import * as ticketActions from "../../../modules/ticket/action";
import "../../../style";
import AllMainFarmSelectedDialog from "../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import TabHeaderAndButton from "../../Common/TabHeaderAndButton";
import CreateTable from "../../CreateTable";
import ConfirmationDialog from "../../FormElement/ConfirmationDialog";
import InfoDialog from "../../FormElement/InfoDialog";
import InputFiled from "../../FormElement/InputFiled";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";

class TicketView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      headerRows: {
        loadDate: "Load Date",
        updatedBy: "Updated By",
        ticketNumber: "Ticket Number",
        originTypeId: "Origin",
        commodityResponseDTO: "Commodity",
        destination: "Destination",
        truckline: "Truckline",
        fieldEstimatedLoadWeight: " Field Estimated Load Weight (lbs)",
        loadNumber: "Load Number Indicator"
      },
      order: "desc",
      orderBy: "",
      open: false,
      showInfo: false,
      searchTerm: this.props.searchTerm || "",
      typingTimeout: 0
    };
  }

  // componentWillMount() {
  //   let farmId = this.props.SubFarmId
  //     ? this.props.SubFarmId
  //     : userFarmDetail().id || this.props.MainFarmId;

  //   const { selectedYear } = this.props;
  //   if (farmId !== DropdownOptions.ALL_MAIN_FARM.id ) {

  //     this.props.actions.getPreferences().then(data=>{
  //       if(data) {
  //         this.props.actions.getTicketList(farmId, selectedYear||new Date().getFullYear());
  //       }
  //       else{
  //         this.props.actions.getTicketList(farmId, new Date().getFullYear());
  //       }
  //     })

  //   }
  // }

  componentDidMount() {
    let farmId = this.props.SubFarmId
      ? this.props.SubFarmId
      : userFarmDetail().id || this.props.MainFarmId;
    const { selectedYear, searchTerm } = this.props;
    if (farmId !== DropdownOptions.ALL_MAIN_FARM.id && selectedYear) {
      this.props.actions.getTicketList(
        farmId,
        selectedYear,
        undefined,
        undefined,
        searchTerm
      );
      searchTerm && this.props.actions.setSearchTerm("");
    }
  }

  handleNextPage = (page, rowsPerPage) => {
    let farmId = this.props.SubFarmId
      ? this.props.SubFarmId
      : userFarmDetail().id || this.props.MainFarmId;
    const { searchTerm } = this.props;
    const { selectedYear } = this.props;
    if (farmId !== DropdownOptions.ALL_MAIN_FARM.id) {
      this.props.actions.getTicketList(
        farmId,
        selectedYear,
        page,
        rowsPerPage,
        searchTerm
      );
    }
  };

  componentWillReceiveProps(nextProps) {
    let farmId = this.props.SubFarmId
      ? nextProps.SubFarmId
      : userFarmDetail().id;
    if (
      nextProps.TicketList &&
      this.props.TicketList !== nextProps.TicketList &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    if (
      nextProps.SubFarmId &&
      nextProps.SubFarmId !== this.props.SubFarmId &&
      nextProps.SubFarmId !== DropdownOptions.ALL_MAIN_FARM.id &&
      (nextProps.selectedYear || nextProps.PrefencesList.harvestYear)
    ) {
      this.props.actions.getTicketList(
        nextProps.SubFarmId,
        this.props.selectedYear || nextProps.PrefencesList.harvestYear
      );
      this.setState({ searchTerm: "" });
    }
    if (
      nextProps.selectedYear &&
      nextProps.selectedYear !== this.props.selectedYear &&
      (!isSuperAdmin() || farmId !== DropdownOptions.ALL_MAIN_FARM.id)
    ) {
      //console.log(nextProps.selectedYear)
      this.props.actions.getTicketList(farmId, nextProps.selectedYear);
      this.setState({ searchTerm: "" });
    }
    if (
      nextProps.PrefencesList &&
      nextProps.PrefencesList.harvestYear !==
        this.props.PrefencesList.harvestYear
    ) {
      this.props.actions.getTicketList(
        farmId,
        nextProps.PrefencesList.harvestYear
      );
      this.setState({ searchTerm: "" });
    }
  }

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };
  craeteRowData = rowData => {
    return (
      rowData &&
      Object.keys(rowData).map(value => {
        let CurrentRow = rowData[value];
        let obj = {};
        var date = new Date(CurrentRow.loadDate);
        obj["fullData"] = CurrentRow;
        obj["loadDate"] = moment(date).format("lll");
        obj["updatedBy"] = CurrentRow.updatedBy;
        obj["updatedAt"] = new Date(CurrentRow.updatedAt).getTime();
        obj["ticketNumber"] = CurrentRow.ticketNumber
          ? CurrentRow.ticketNumber
          : "NIL";
        obj["originTypeId"] = CurrentRow.originType
          ? CurrentRow.primarySource
            ? `${CurrentRow.primarySource.name} (${CurrentRow.originType.type})`
            : "NIL"
          : "NIL";
        obj["commodityResponseDTO"] = CurrentRow.commodityResponseDTO
          ? CurrentRow.commodityResponseDTO.name
          : "NIL";
        obj["destination"] = CurrentRow.destinationResponseDTO
          ? CurrentRow.destinationResponseDTO.name
          : "NIL";
        obj["truckline"] = CurrentRow.truckline
          ? CurrentRow.truckline.name
          : "NIL";
        obj["fieldEstimatedLoadWeight"] = CurrentRow.fieldEstimatedLoadWeight
          ? CurrentRow.fieldEstimatedLoadWeight + "lbs"
          : "-lb";
        obj["id"] = CurrentRow.id ? CurrentRow.id : "";
        obj["disabled"] = CurrentRow.disabled ? CurrentRow.disabled : false;
        obj["stage"] = CurrentRow.primaryContractNumber
          ? CurrentRow.primaryContractNumber.contractStageResponseDTO
            ? CurrentRow.primaryContractNumber.contractStageResponseDTO.stage
            : ""
          : "";
        obj["loadNumber"] = CurrentRow.loadNumber ? CurrentRow.loadNumber : "";
        return obj;
      })
    );
  };
  deleteRow = (id, data) => {
    this.setState({
      open: true,
      id: id,
      ticketNumber: data.ticketNumber
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
      showInfo: false
    });
  };

  handleOk = () => {
    const { id, ticketNumber } = this.state;
    this.handleClose();
    this.props.actions.deleteTicket(ticketNumber);
  };

  editRow = (id, data, stage) => {
    this.props.actions.setSearchTerm(this.state.searchTerm);
    stage === "Agreed" || stage === ""
      ? this.props.actions.editSelectedTicket(data)
      : this.setState({ showInfo: true });
  };

  handleChange = event => {
    const keyword = event.target.value;
    if (keyword.match(/^(\w|-){0,21}$/)) {
      const { typingTimeout } = this.state;
      let farmId = this.props.SubFarmId
        ? this.props.SubFarmId
        : userFarmDetail().id || this.props.MainFarmId;

      const { selectedYear, actions } = this.props;
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      this.setState({
        searchTerm: keyword,
        typingTimeout: setTimeout(function() {
          keyword
            ? actions.getTicketList(
                farmId,
                selectedYear,
                undefined,
                undefined,
                keyword
              )
            : actions.getTicketList(farmId, selectedYear);
        }, 1000)
      });
    }
  };

  render() {
    const { order, orderBy, open, showInfo, searchTerm } = this.state;
    const {
      TicketList,
      ErrorMessage,
      pageCount,
      totalElements,
      fetchingComplete
    } = this.props;

    return (
      <div className="ticket-body">
        <InfoDialog open={showInfo} handleClose={this.handleClose} />
        <ConfirmationDialog
          open={open}
          handleClose={this.handleClose}
          handleOk={this.handleOk}
        />
        <TabHeaderAndButton
          header="Tickets"
          path="/app/createticket"
          btnLabel="New ticket"
          searchField={
            <InputFiled
              value={searchTerm}
              placeholder="Search Ticket..."
              handleChange={this.handleChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
            />
          }
          isDisabled={
            isSuperAdmin() &&
            this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id
          }
        />
        {isSuperAdmin() && this.props.MainFarmId == "ALL_MAIN_FARM" ? (
          <AllMainFarmSelectedDialog />
        ) : (
          <div>
            {/* {fetchingComplete ? (
                ErrorMessage && ErrorMessage.message ? (
                  <div className="ErrorMessage">{ErrorMessage.message}</div>
                ) : ( */}
            <CreateTable
              orderBy={orderBy}
              order={order}
              onRequestSort={this.handleRequestSort}
              headerRows={this.state.headerRows}
              rowData={this.craeteRowData(TicketList) || []}
              delete={this.deleteRow}
              fetchingComplete={fetchingComplete}
              edit={this.editRow}
              highlightPrimaryColumn={true}
              location="app/editticket"
              pageCount={pageCount}
              totalElements={totalElements}
              handleNextPage={this.handleNextPage}
            />
            {/* )
              ) : (
                <Loader />
              )} */}
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state, props) {
  return {
    TicketList: state.ticketReducer.TicketList,
    fetchingComplete: state.ticketReducer.fetchingComplete,

    pageCount: state.ticketReducer.pageCount,
    totalElements: state.ticketReducer.totalElements,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear,
    PrefencesList: state.preferencesReducer.PrefencesList,
    searchTerm: state.ticketReducer.searchTerm
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...ticketActions,
        getPreferences,
        putPreferences
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TicketView);



// WEBPACK FOOTER //
// ./src/components/private/Tickets/TicketView.js